import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AccountState, Account, AccountActions, ServerEventsActions } from '@app/_store';
import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap/dropdown';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgIf,
    FormsModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    RouterLink,
    AsyncPipe,
  ],
})
export class AccountComponent {
  account$: Observable<Account> = inject(Store).select(AccountState.account);

  isDevelopment: boolean;

  constructor(private store: Store) {
    this.isDevelopment = !environment.production;
  }

  toggleHiddenAdminFeatures() {
    this.store.dispatch(new AccountActions.ToggleHiddenAdminFeatures());
  }

  logout(): void {
    this.store
      .dispatch(new ServerEventsActions.Disconnect())
      .pipe(
        tap(() => {
          this.store.dispatch(new AccountActions.Logout());
        })
      )
      .subscribe();
  }
}
